/* tslint:disable:typedef-whitespace no-trailing-whitespace */

import {TaskUpdate, TaskUpdateType} from "@/models/task.update";
import {basename, bytesToSize} from "@/util/util";

/**
 *
 * @class TaskRemoteSimulationDelete
 *
 * @brief incremental progress reporting on batch deletion of remote simulations
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2025
 *
 */
export class TaskRemoteSimulationDelete extends TaskUpdate {

  /** the number of deleted files/folders so far */
  public deleted: number;

  /** the batch size */
  public total:    number;

  /** the last file/folder we deleted */
  public lastItem: string;

  /**
   * standard constructor, you have to uniquely identify the task progress stream (id)
   * and provide the type of progress update (type).
   *
   * @param id       the unique id of the task progress stream to clear (the context)
   * @param lastItem the last simulation we deleted
   * @param deleted  the number of simulations deleted so far
   * @param total    the batch size
   *
   */
  constructor(id: string, lastItem: string, deleted: number, total: number) {

    super(id, TaskUpdateType.Progress,(deleted / total) * 100.0);


    this.deleted  = deleted;
    this.total    = total;
    this.lastItem = lastItem;

  }

  /** subclasses that can render their own update should return non-empty HTML */
  render(): string {

    return `
<div class="task-file-upload-sub-panel">

  <div style="display: inline-block; width: 32px;">
    <span class="tsp-icon" style="width: 32px; height: 32px; background-color: #a1a1a1; -webkit-mask-image: url(/assets/images/delete-64.png); -webkit-mask-size: 32px 32px; mask-size: 32px 32px; mask-image: url('/assets/images/delete-64.png'); background-size: contain;"></span>
  </div>

  <div style="display: inline-block; width: calc(100% - 40px);">

    <div style="display: inline-block;">
      <span class="tsp-label">${this.lastItem}</span>
    </div>

    <div class="tsp-progress-border">
      <div class="tsp-progress-bar" style="width: ${this.progress.toFixed(2)}%"></div>
    </div>

    <div style="display: block;">
      <span class="tsp-size">${this.deleted} of ${this.total}</span>
    </div>

  </div>

</div>
`;


  }


}
